import _ from 'lodash';

const getUseModel = (data) => {
    let cloneData = _.cloneDeep(data);
    let returnData = [];
    cloneData.forEach(d => {
        returnData.push(d)
    })
    return returnData
}


const setChartData = (inData) => {
    let nodes = [], links = [], categories = [];
    let data = null;
    data = _.cloneDeep(inData);

    /* 设置node | categories */
    let node = {
        id: data.id,
        parent_id: data.parent_id,
        level: data.level,
        name: data.name,
        parentNode: [data.id]
    };
    categories.push({ name: data.name })

    if (data.children && data.children.length > 0) {
        nodes.push(node)
        nodes.push(...setNodeInfo(data.children, node.parentNode))
        /* 设置link */
        setLinkInfo(data)
    } else {
        nodes.push(node)
    }


    return { nodes, links, categories }

    /* ---------------------------------- */

    function setNodeInfo(children, parent) {
        let childs = _.cloneDeep(children);
        let re_node = [];
        childs.forEach(child => {
            let node = {
                id: child.id,
                parent_id: child.parent_id,
                level: child.level,
                name: child.name,
                parentNode: [...parent, child.id]
            }
            categories.push({ name: child.name })

            if (child.children && child.children.length > 0) {
                re_node.push(node)
                re_node.push(...setNodeInfo(child.children, node.parentNode))
            } else {
                re_node.push(node)
            }
        })
        return re_node;
    }

    function setLinkInfo(linkInfo) {
        if (linkInfo.children && linkInfo.children.length > 0) {
            linkInfo.children.forEach(child => {
                let link = {
                    source: linkInfo.id,
                    target: child.id,
                }
                links.push(link)
                if (child.children && child.children.length > 0) {
                    setLinkInfo(child)
                }
            })
        }
    }

}
export {
    getUseModel,
    setChartData
}